module.exports = __webpack_public_path__ + "media/newstyle/images/logo-amazon-color-af4365b8d48123eeaa358a2b37de1407.png";